import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight, FaHome } from 'react-icons/fa';

interface BreadcrumbItem {
    label: string;
    path?: string;
    icon?: React.ReactNode;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => {
    return (
        <nav className={`flex items-center space-x-2 text-sm ${className}`} aria-label="Breadcrumb">
            <Link
                to="/"
                className="flex items-center text-gray-500 hover:text-blue-600 transition-colors"
            >
                <FaHome className="w-4 h-4" />
            </Link>

            {items.map((item, index) => (
                <React.Fragment key={index}>
                    <FaChevronRight className="w-3 h-3 text-gray-400" />

                    {item.path && index < items.length - 1 ? (
                        <Link
                            to={item.path}
                            className="flex items-center text-gray-500 hover:text-blue-600 transition-colors"
                        >
                            {item.icon && <span className="mr-1">{item.icon}</span>}
                            {item.label}
                        </Link>
                    ) : (
                        <span className="flex items-center text-gray-900 font-medium">
                            {item.icon && <span className="mr-1">{item.icon}</span>}
                            {item.label}
                        </span>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
};

export default Breadcrumb;
